import React, { useRef, useEffect } from "react";
import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";

import useFigure from "../../hooks/useFigure"; //Get figure hook

// styles
import { Wrapper } from "./styles";

const ThreeFigure = ({ figureData }) => {
  const defaultFigure = figureData || {
    name: "cylinder",
    values: {
      height: 0.4,
      width: 2
    }
  };

  const mount = useRef(null);
  const { figure } = useFigure(defaultFigure); //

  useEffect(() => {
    let mountCopy = mount; //Use mount in useEffect to resolve errors
    if (figure) {
      let width = mountCopy.current.clientWidth; //Size of three window
      let height = mountCopy.current.clientHeight; //Size of three window
      let frameId; //Animation frame

      const scene = new THREE.Scene(); //Create a new scenary
      const camera = new THREE.PerspectiveCamera(75, width / height, 0.1, 1000); //Set the camera

      //Instance renderer, this mount the scene and camera, and change in each new frame
      const renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true //To transparent
      });

      scene.add(figure); //add figure to scenary

      const lights = [];
      lights[0] = new THREE.PointLight(0xffffff, 1, 0);
      lights[1] = new THREE.PointLight(0xffffff, 1, 0);
      lights[2] = new THREE.PointLight(0xffffff, 1, 0);

      lights[0].position.set(0, 20, 0);
      lights[1].position.set(20, 0, 0);
      lights[2].position.set(0, 0, 20);

      scene.add(lights[0]);
      //scene.add(lights[1]);
      scene.add(lights[2]);

      const ambientLight = new THREE.AmbientLight(0xffffff, 0.2);
      scene.add(ambientLight);

      //Provisional helper
      //var axesHelper = new THREE.AxesHelper(5);
      //scene.add(axesHelper);

      camera.position.z = 4; //set z axis camera

      const orbitControl = new OrbitControls(camera, renderer.domElement);
      orbitControl.update();

      renderer.setClearColor(0x000000, 0); //Set bacground color transparent
      renderer.setSize(width, height); //Set rendered size

      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.BasicShadowMap;

      //Render the scene, is called in each frame change
      const renderScene = () => {
        renderer.render(scene, camera);
      };

      //Resize the scene
      const handleResize = () => {
        width = mountCopy.current.clientWidth;
        height = mountCopy.current.clientHeight;
        renderer.setSize(width, height);
        camera.aspect = width / height;
        camera.updateProjectionMatrix();
        renderScene();
      };

      //Animate the figure
      const animate = () => {
        orbitControl.update();
        renderScene();
        frameId = window.requestAnimationFrame(animate);
      };

      //To start animation
      const start = () => {
        if (!frameId) {
          frameId = requestAnimationFrame(animate);
        }
      };

      //To stop animation
      const stop = () => {
        cancelAnimationFrame(frameId);
        frameId = null;
      };

      //Init dom elements
      mountCopy.current.appendChild(renderer.domElement);
      window.addEventListener("resize", handleResize);
      start();

      //On unmount
      return () => {
        stop();
        window.removeEventListener("resize", handleResize);
        mountCopy.current.removeChild(renderer.domElement);

        scene.remove(figure);
      };
    }
  }, [figure]);

  return (
    <Wrapper
      ref={
        mount //div events and parameters
      }
    />
  );
};

export default ThreeFigure;
